<!-- Created by 337547038 on 2020/8/14 0014. -->
<template>
  <div class="shen-zhen">
    <div class="main-title">
      <h3>深圳市高校地域分布情况</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">所选高校专利发明申请公开量、发明授权量公开量、实用新型公开量、外观设计公开量、PCT申请公开量({{yearRange}})，默认显示深圳大学
          ，鼠标移动到某学校名称处，则切换到对应学校统计图表
        </div>
      </div>
    </div>
    <div class="map-img">
      <div class="map-container">
        <img class="map-img" src="../../assets/img/map.png">
      </div>
      <a href="javascript:;" @click="schoolClick(item)" v-for="item in schoolList"
         :class="{[item.cls]:true,'active':item.name===schoolActive}" :key="item.value">{{item.name}}</a>
    </div>
    <div class="patent-total">
      <div class="item" :class="['item-'+index]" v-for="(item,index) in totalList" :key="index">
        <h3 v-html="item.name"></h3>
        <div class="line"></div>
        <p v-html="item.num"></p>
      </div>
    </div>
    <div class="main-title">
      <h3>深圳市高校近五年专利情况</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">深圳市高校专利近五年发明申请公开量、发明授权量、实用新型公开量、外观设计公开量、PCT申请公开量</div>
      </div>
    </div>
    <div class="charts">
      <TimeLineBarPie :type="2" :isMobile="isMobile"></TimeLineBarPie>
    </div>
    <div class="main-title">
      <h3>深圳市高校专利有效量情况</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">深圳市所有高校专利有效量按（发明、实用新型、外观设计）统计，无专利的高校不展示</div>
      </div>
    </div>
    <div class="charts">
      <Echarts :option="patentNum" :height="isMobile?'300px':'700px'"></Echarts>
    </div>
    <div class="main-title">
      <h3>深圳市高校专利技术领域及产业分布</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">高校专利申请公开量在战略性新兴产业分类下的一级分类前五({{yearRange}})</div>
      </div>
    </div>
    <div class="charts no-margin">
      <Echarts :option="chartArea" :height="isMobile?'200px':'650px'"></Echarts>
    </div>
  </div>
</template>

<script>
import Echarts from '@/components/Echarts'
import TimeLineBarPie from '@/components/TimeLineBarPie'
import Query from '@/utils/query'

export default {
  name: "ShenZhen",
  data() {
    return {
      schoolList: [
        {
          name: '清华大学深圳国际研究生院',
          cls: 'c1'
        },
        {
          name: '广东新安职业技术学院',
          cls: 'c2'
        },
        {
          name: '南方科技大学',
          cls: 'c3'
        },
        {
          name: '深圳职业技术大学',
          cls: 'c4'
        },
        {
          name: '哈尔滨工业大学(深圳)',
          cls: 'c5'
        },
        {
          name: '深圳大学',
          cls: 'c6'
        },
        {
          name: '北京大学深圳研究生院',
          cls: 'c7'
        },
        {
          name: '深圳北理莫斯科大学',
          cls: 'c8'
        },
        {
          name: '香港中文大学（深圳）',
          cls: 'c9'
        },
        {
          name: '深圳技术大学',
          cls: 'c10'
        },
        {
          name: '深圳信息职业技术大学',
          cls: 'c11'
        },
        {
          name: '中山大学（深圳）',
          cls: 'c12'
        },
      ],
      schoolActive: '深圳大学', // 当前选择的学校
      totalList: [
        {name: '发明申请公开量（件）', num: 0},
        {name: '外观设计公开量（件）', num: 0},
        {name: 'PCT申请公开量（件）', num: 0},
        {name: '实用新型公开量（件）', num: 0},
        {name: '发明授权公开量（件）', num: 0}
      ],
      schoolData: '',
      patentNum: {}, // 高校专利有效量情况
      chartArea: {}, // 专利技术领域及产业分布
      isMobile: false
    }
  },
  mixins: [Query],
  props: {},
  components: {Echarts, TimeLineBarPie},
  methods: {
    // 高校专利有效量，图3
    getPatentNum() {
      this.getAjax(3, (data) => {
        let schoolData = []
        let FM = [] // 发明
        let SGSJ = []
        let SYXX = []
        for (let key in data) {
          schoolData.push(key)
          FM.push(data[key].Effective_Quantity_FM)
          SGSJ.push(data[key].Effective_Quantity_SGSJ) // 外观
          SYXX.push(data[key].Effective_Quantity_SYXX)
        }
        this.patentNum = {
          tooltip: {},
          angleAxis: {
            type: 'category',
            data: schoolData,
            axisLabel: {
              fontSize: this.isMobile?10:16,
              margin: this.isMobile?5:19,
              formatter: (params) => {
                let str = params
                if(this.isMobile && str.length > 4){
                  str = str.replace(/(.{1,4})/g,'$1\n')
                }
                return str
              }
            }
          },
          radiusAxis: {},
          polar: {
            center: ['50%',this.isMobile?'55%':'50%'],
            radius: this.isMobile?'60%':'80%'
          },
          color: ['#e8d621', '#28d9dc', '#1683d4'],
          series: [
            {
              type: 'bar',
              data: FM, // [1, 2, 3, 4, 3, 5, 1],
              coordinateSystem: 'polar',
              name: '发明',
              stack: 'a'
            },
            {
              type: 'bar',
              data: SYXX,
              coordinateSystem: 'polar',
              name: '实用新型',
              stack: 'a'
            },
            {
              type: 'bar',
              data: SGSJ,
              coordinateSystem: 'polar',
              name: '外观设计',
              stack: 'a'
            }
          ],
          legend: {
            show: true,
            textStyle: {
              fontSize: this.isMobile?12:16
            },
            itemWidth: this.isMobile?12:25,
            itemHeight: this.isMobile?7:14
            // data: ['发明', '实用新型', '外观设计']
          }
        }
      })
    },
    // 图4
    getChartsArea() {
      this.getAjax(4, (data) => {
        let series = []
        let max = 0
        for (let key in data) {
          series.push({
            name: key,
            value: data[key]
          })
          if (data[key] > max) {
            max = data[key]
          }
        }
        this.chartArea = {
          tooltip: {
            trigger: 'item',
            formatter: "{b} : {c}({d}%)"
          },
          legend: {
            //  data: ['展现', '点击', '访问', '咨询', '订单']
            textStyle: {
              fontSize: this.isMobile?12:13
            },
            itemWidth: this.isMobile?12:25,
            itemHeight: this.isMobile?7:14
          },
          grid: {
            bottom: 0
          },
          series: [
            {
              name: '',
              type: 'funnel',
              left: '10%',
              top: this.isMobile?80:60,
              //x2: 80,
              bottom: 60,
              width: '80%',
              // height: {totalHeight} - y - y2,
              min: 0,
              max: max,
              minSize: '10%',
              maxSize: '100%',
              sort: 'descending',
              height: this.isMobile?120:500,
              gap: 2,
              label: {
                show: true,
                position: 'inside',
                fontSize: this.isMobile?10:16,
                formatter: '{b}\n{c}({d}%)'
              },
              labelLine: {
                length: 10,
                lineStyle: {
                  width: 1,
                  type: 'solid'
                }
              },
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 1
              },
              emphasis: {
                label: {
                  fontSize: 20
                }
              },
              data: series
            }
          ]
        }
      })
    },
    schoolClick(item) {
      this.schoolActive = item.name
      this.getSchoolTotal(item.name)
    },
    // 高校地域分布情况，图1
    schoolNum() {
      this.schoolData = ''
      this.getAjax(1, data => {
        this.schoolData = data
        this.getSchoolTotal(this.schoolActive)
      })
    },
    getSchoolTotal(active) {
      if (this.schoolData) {
        for (let key in this.schoolData) {
          if (key === active) {
            const ii = this.schoolData[active]
            this.totalList = [
              {name: '发明申请公开量（件）', num: ii.FMSZ_Amount_Of_Public},
              {name: '发明授权公开量（件）', num: ii.FMSQ},
              {name: '实用新型公开量（件）', num: ii.SYXX_Amount_Of_Public},
              {name: '外观设计公开量（件）', num: ii.WGSJ_Amount_Of_Public},
              {name: 'PCT申请公开量（件）', num: ii.PCT_Amount_Of_Public},
            ]
          }
        }
      }
    }
  },
  computed: {},
  created(){
    // 判断是否移动端
    this.isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  },
  mounted() {
    this.getPatentNum()
    this.getChartsArea()
    this.schoolNum()
  }
}
</script>
